import React from 'react'

const Status = () => {
    return (
        <>
            <div className="container mx-auto px-6 py-8">
                <h3 className="text-gray-700 text-3xl font-medium">Dashboard</h3>

                <div className="mt-4">
                    <div className="flex flex-wrap text-xl mx-6">
                        This is the list of requests made for in house FIR generation. Please choose a report to continue
                    </div>
                </div>
            </div>
        </>
    )
}

export default Status